import Layout from "@/layout";
export default {
    meta: {
        title: "保险",
        icon: "b-bx",
    },
    path: "/insure",
    component: Layout,
    children: [
        {
            path: "/insuresafe/tzindex",
            name: "insuresafeTzindex",
            component: () => import("@/views/insuresafe/tzindex"),
            meta: {
                title: "保单列表",
                auth: [],
                img: "bx",
            },
        },
        {
            path: "/RecordList/BxIndex",
            name: "BxRecordList",
            component: () => import("@/views/RecordList/BxIndex"),
            meta: {
                title: "视频列表",
                auth: [],
                img: "bdlb",
            },
            props: (route) => {
                return route.query;
            },
        },

        // {
        //     path: '/insuresafe/xmgl',
        //     name: 'insuresafeXmgl',
        //     component: () => import('@/views/project/xmgl'),
        //     meta: {
        //         title: '项目管理',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insuresafe/gcgl',
        //     name: 'insuresafeGcgl',
        //     component: () => import('@/views/project/list'),
        //     meta: {
        //         title: '工程管理',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insuresafe/addProject',
        //     name: 'insuresafeAddProject',
        //     component: () => import('@/views/project/add'),
        //     meta: {
        //         title: '工程新增',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insuresafe/openView',
        //     name: 'insuresafeOpenView',
        //     component: () => import('@/views/project/openView.vue'),
        //     meta: {
        //         title: '工程查看',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insuresafe/tzadd',
        //     name: 'insuresafeTzadd',
        //     hide: true,
        //     component: () => import('@/views/insuresafe/tzadd'),
        //     meta: {
        //         title: '保单录入',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insuresafe/tzDetail',
        //     name: 'insuresafeTzDetail',
        //     hide: true,
        //     component: () => import('@/views/insuresafe/tzDetail'),
        //     meta: {
        //         title: '保单详情',
        //         auth: [],
        //         img: "azx"
        //     },
        //     props: route => {
        //         return route.query;
        //     }
        // },
        {
            path: "/insuresafe/tztisindex",
            name: "insuresafeTztisindex",
            component: () => import("@/views/insuresafe/tztisindex"),
            meta: {
                title: "保单列表",
                auth: [],
                img: "bdlb",
            },
            props: (route) => {
                return route.query;
            },
        },
        {
            path: "/RecordList/index",
            name: "RecordList",
            component: () => import("@/views/RecordList/index"),
            meta: {
                title: "视频列表",
                auth: [],
                img: "bdlb",
            },
            props: (route) => {
                return route.query;
            },
        },
        // {
        //     path: '/insuresafe/index',
        //     name: 'insuresafeIndex',
        //     component: () => import('@/views/insuresafe/index'),
        //     meta: {
        //         title: '安责险',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insuresafe/user',
        //     name: 'insuresafeUser',
        //     component: () => import('@/views/insuresafe/user'),
        //     meta: {
        //         title: '安责险',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insuresafe/bxconfirm',
        //     name: 'bxinsuresafeConfirm',
        //     component: () => import('@/views/insuresafe/confirm'),
        //     meta: {
        //         title: '安责险审核',
        //         auth: [],
        //         img: "azx"
        //     }
        // },
        // {
        //     path: '/insureidi/applicant',
        //     name: 'applicantIndex',
        //     component: () => import('@/views/insureidi/index'),
        //     meta: {
        //         title: 'IDI保险',
        //         auth: [],
        //         img: "idi"
        //     }
        // },
        // {
        //     path: '/insureidi/intentbook',
        //     name: 'bxintentbookCheck',
        //     component: () => import('@/views/insureidi/confirm'),
        //     meta: {
        //         title: 'IDI审核',
        //         auth: [],
        //         img: "idi"
        //     }
        // },
        // {
        //     path: '/insureidi/tisConfirm',
        //     name: 'tisConfirm',
        //     component: () => import('@/views/insureidi/tisConfirm'),
        //     meta: {
        //         title: 'tis审核',
        //         auth: [],
        //         img: "idi"
        //     }
        // },
        // {
        //     path: '/insuresafe/byThird',
        //     name: 'insuresafeByThird',
        //     hide: true,
        //     component: () => import('@/views/byThird/index'),
        //     meta: {
        //         title: '安责险录入',
        //         auth: [],
        //         img: "idi"
        //     }
        // },
        // {
        //     hide: true,
        //     path: '/insuresafe/add',
        //     name: 'insuresafeAdd',
        //     component: () => import('@/views/insuresafe/add'),
        //     meta: {
        //         img: "idi",
        //         add: "新增意向书",
        //         edit: "编辑意向书",
        //         confirm: "审核意向书",
        //         confirm2: "更新意向书",
        //         tisConfirm: "审核意向书",
        //         view: "查看意向书",
        //         auth: [],
        //         img: "idi"
        //     },
        //     props: route => {
        //         return route.query;
        //     }
        // },
        // {
        //     path: '/insuresafe/tisConfirm',
        //     name: 'insuresafeTisConfirm',
        //     component: () => import('@/views/insuresafe/tisConfirm'),
        //     meta: {
        //         title: 'tis审核',
        //         auth: [],
        //         img: "idi"
        //     }
        // },
        // {
        //     path: '/insuresafe/tztisServicePlan',
        //     name: 'insuresafeTztisServicePlan',
        //     component: () => import('@/views/insuresafe/tztisServicePlan'),
        //     meta: {
        //         title: '服务任务',
        //         auth: [],
        //         img: "idi"
        //     }
        // },
        {
            path: "/insuresafe/insuranceDetail",
            name: "insuresafeInsuranceDetail",
            component: () => import("@/views/insuresafe/insuranceDetail/insuranceDetail"),
            meta: {
                title: "保单详情",
                auth: [],
                img: "idi",
            },
        },
        {
            path: "/insuresafe/TisInsuranceDetail",
            name: "insuresafeTisInsuranceDetail",
            component: () => import("@/views/insuresafe/TisInsuranceDetail/TisInsuranceDetail"),
            meta: {
                title: "保单详情",
                auth: [],
                img: "idi",
            },
        },
    ],
};
